import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

// Async thunk for fetching cities
export const fetchCities = createAsyncThunk(
  "lcAds/fetchCities",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      if (state.lcAds.needCities.length > 0) {
        return state.lcAds.needCities;
      }

      const response = await axiosClient.get("need/needPlaceName");
      if (response.status === 200) {
        return response.data.data;
      } else {
        return rejectWithValue(response.data.msg);
      }
    } catch (error) {
      return rejectWithValue("Error fetching cities");
    }
  }
);

// Async thunk for fetching need titles
export const fetchNeedTitles = createAsyncThunk(
  "lcAds/fetchNeedTitles",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`need/getNeedTitles`, {
        params,
      });
      if (response.data.statusCode === 200) {
        return response.data.Data;
      } else {
        return rejectWithValue(response.data.msg || "Failed to fetch data");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data"
      );
    }
  }
);

const initialState = {
  needTitles: [],
  titlesLoading: false,
  errorTitles: null,
  activeTab: "Customers",
  searchTerm: "",
  selectedSubCategory: null,
  selectedItem: null,
  radius: 15,
  upcomingProducts: [],
  visibleCategories: [],
  showAll: false,
  searchQuery: "",
  searchText: "",
  bizzLca: [],
  selectedGurdwara: null,
  myOffers: [],
  parentMsg: null,
  selectedAd: null,
  month: "",
  city: "",
  sortBy: "",
  productCities: [],
  guruSubCat: [],
  hideSkipped: true,
  skippedAd: null,
  totalCount: 0,
  error: null,
  viewCustType: false,
  gottonData: {},
  tooltipOpen: false,
  recomandModal: false,
  currentPage: 1,
  needCities: [],
  citiesLoading: false,
  errorCities: null,
  lastFetchTime: null,
};

const localCommunityAdsSlice = createSlice({
  name: "lcAds",
  initialState,
  reducers: {
    resetLca(state) {
      state.activeTab = "Customers";
      state.searchTerm = "";
      state.selectedSubCategory = null;
      state.selectedItem = null;
      state.radius = 0;
      state.searchQuery = "";
      state.city = "";
      state.month = "";
      state.hideSkipped = true;
      state.searchText = "";
      state.currentPage = 1;
      state.sortBy = "";
    },
    resetFilters(state) {
      state.activeTab = "Customers";
      state.searchTerm = "";
      state.selectedSubCategory = null;
      state.selectedItem = null;
      state.radius = 0;
      state.city = "";
      state.month = "";
      state.hideSkipped = true;
      state.currentPage = 1;
      state.sortBy = "";
    },
    resetNeedTitles(state) {
      state.needTitles = [];
      state.titlesLoading = false;
      state.errorTitles = null;
    },
    setShowAll(state, action) {
      state.showAll = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    setSearchText(state, action) {
      state.searchText = action.payload;
    },
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    setFullName(state, action) {
      state.fullName = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setSelectedSubCategory(state, action) {
      state.selectedSubCategory = action.payload;
    },
    setSelectedItem(state, action) {
      state.selectedItem = action.payload;
    },
    setRadius(state, action) {
      state.radius = action.payload;
    },
    setUpcomingProducts(state, action) {
      state.upcomingProducts = action.payload;
    },
    setLca(state, action) {
      state.Lca = action.payload;
    },
    setVisibleCategories(state, action) {
      state.visibleCategories = action.payload;
    },
    setBizzLca(state, action) {
      state.bizzLca = action.payload;
    },
    setSelectedGurdwara(state, action) {
      state.selectedGurdwara = action.payload;
    },
    setMyOffers(state, action) {
      state.myOffers = action.payload;
    },
    setParentMsg(state, action) {
      state.parentMsg = action.payload;
    },
    setSelectedAd(state, action) {
      state.selectedAd = action.payload;
    },
    setMonth(state, action) {
      state.month = action.payload;
    },
    setCity(state, action) {
      state.city = action.payload;
    },
    setSortBy(state, action) {
      state.sortBy = action.payload;
    },
    setProductCities(state, action) {
      state.productCities = action.payload;
    },
    setGuruSubCat(state, action) {
      state.guruSubCat = action.payload;
    },
    setHideSkipped(state, action) {
      state.hideSkipped = action.payload;
    },
    setSkippedAd(state, action) {
      state.skippedAd = action.payload;
      const ad = action.payload;
      const updateArray = (array) =>
        array.map((item) => (item.Id === ad.Id ? ad : item));

      if (ad?.needSkipCustomer === 1 && state.hideSkipped) {
        // state.Lca = state.Lca.filter((item) => item.Id !== ad.Id);
        // state.allProducts = state.allProducts.filter(
        //   (item) => item.Id !== ad.Id
        // );
      } else {
        // const existingLcaIds = state.Lca.map((item) => item.Id);
        // if (existingLcaIds.includes(ad.Id)) {
        //   state.Lca = updateArray(state.Lca);
        // } else {
        //   state.Lca = [...state.Lca, ad];
        // }
        // const existingProductIds = state.allProducts.map((item) => item.Id);
        // if (existingProductIds.includes(ad.Id)) {
        //   state.allProducts = updateArray(state.allProducts);
        // } else if (ad.engagedCouple !== 1) {
        //   state.allProducts = [...state.allProducts, ad];
        // }
      }
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    setViewCustType(state, action) {
      state.viewCustType = action.payload;
    },
    setGottonData(state, action) {
      state.gottonData = action.payload;
    },
    setTooltipOpen(state, action) {
      state.tooltipOpen = action.payload;
    },
    setRecomandModal(state, action) {
      state.recomandModal = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setNeedCities(state, action) {
      state.needCities = action.payload;
    },
    setLastFetchTime(state, action) {
      state.lastFetchTime = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCities.pending, (state) => {
        if (state.needCities.length === 0) {
          state.citiesLoading = true;
        }
        state.errorCities = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.needCities = action.payload;
        state.citiesLoading = false;
        state.errorCities = null;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.citiesLoading = false;
        state.errorCities = action.payload || "Error fetching cities";
      })
      // fetchNeedTitles cases
      .addCase(fetchNeedTitles.pending, (state) => {
        state.titlesLoading = true;
        state.errorTitles = null;
      })

      // .addCase(fetchNeedTitles.fulfilled, (state, action) => {
      //   const newItems = Array.isArray(action.payload) ? action.payload : [];

      //   // Avoid duplicates
      //   const existingIds = new Set(state.needTitles.map((item) => item.id));
      //   const uniqueItems = newItems.filter(
      //     (item) => !existingIds.has(item.id)
      //   );

      //   state.needTitles = [...state.needTitles, ...uniqueItems];
      // })
      .addCase(fetchNeedTitles.fulfilled, (state, action) => {
        const newItems = Array.isArray(action.payload) ? action.payload : [];

        const existingIds = new Set(state.needTitles.map((item) => item.id));
        const uniqueItems = newItems.filter(
          (item) => !existingIds.has(item.id)
        );

        state.needTitles = [...state.needTitles, ...uniqueItems];
        state.titlesLoading = false;
      })

      .addCase(fetchNeedTitles.rejected, (state, action) => {
        state.titlesLoading = false;
        state.errorTitles = action.payload || "Error fetching need titles";
      });
  },
});

export const {
  resetLca,
  resetFilters,
  resetNeedTitles,
  setActiveTab,
  setSearchTerm,
  setSelectedSubCategory,
  setSelectedItem,
  setRadius,
  setUpcomingProducts,
  setLca,
  setVisibleCategories,
  setShowAll,
  setSearchQuery,
  setSearchText,
  setBizzLca,
  setSelectedGurdwara,
  setMyOffers,
  setParentMsg,
  setSelectedAd,
  setMonth,
  setCity,
  setSortBy,
  setProductCities,
  setGuruSubCat,
  setHideSkipped,
  setSkippedAd,
  setTotalCount,
  setViewCustType,
  setGottonData,
  setTooltipOpen,
  setRecomandModal,
  setCurrentPage,
  setNeedCities,
  setLastFetchTime,
} = localCommunityAdsSlice.actions;

export default localCommunityAdsSlice.reducer;
